"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconDevicesMultiSpeaker = IconDevicesMultiSpeaker;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../icons/IconDeviceMultispeaker/index.js");
/**
 * @deprecated The name IconDevicesMultiSpeaker is deprecated and will be archived soon. Use IconDeviceMultispeaker instead.
 */
function IconDevicesMultiSpeaker(props) {
  return /*#__PURE__*/_react["default"].createElement(_index.IconDeviceMultispeaker, props);
}